if (!customElements.get('product-form')) {

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {

      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      document.querySelectorAll('.js-table-addcart').forEach(
        (button) => button.addEventListener('click', this.tableVariantAddCart.bind(this, button))
      );

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const quantityBreaks = document.querySelector('quantity-breaks');
      let bodyData;
      let currentId = ''; // 定义一个变量来存储 ID，用于后续报错追踪

      // --- 逻辑判断：是否走多 SKU 加购逻辑 ---
      if (quantityBreaks) {
        // A. 解析变体数据
        const variantsData = JSON.parse(quantityBreaks.querySelector('script[type="application/json"]').textContent);
        
        // B. 获取当前选中的 Radio 对应的 Value (数量) 和对应的 Label
        const selectedInput = quantityBreaks.querySelector('input[name="quantity"]:checked');
        const count = parseInt(selectedInput.value);
        
        // 找到 input 紧随其后的 label 容器
        const labelContainer = quantityBreaks.querySelector(`label[for="${selectedInput.id}"]`);
        const selectorItems = labelContainer.querySelectorAll('.quantity-break__selector-item');
        
        const items = [];

        // C. 循环处理每一组 SKU 选择器
        selectorItems.forEach((item, index) => {
          if (index < count) {
            // 获取当前组内所有的下拉框值
            const selects = Array.from(item.querySelectorAll('.variant-dropdown'));
            const selectedOptions = selects.map(select => select.value);

            // 在 JSON 中匹配 ID (option1 对应第一个 select, option2 对应第二个)
            const matched = variantsData.find(v => {
              return selectedOptions.every((val, idx) => v[`option${idx + 1}`] === val);
            });

            if (matched) {
              items.push({
                id: matched.id,
                quantity: 1
              });
            }
          }
        });

        // D. 构造 JSON Payload
        const payload = { items: items };
        currentId = 'bundle'; // 捆绑销售使用固定标识

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((s) => s.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.headers['Content-Type'] = 'application/json';
        bodyData = JSON.stringify(payload);
      } else {
        // --- 默认 Dawn 原始逻辑 ---
        const formData = new FormData(this.form);
        currentId = formData.get('id'); // 从表单获取 ID

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        delete config.headers['Content-Type'];
        bodyData = formData;
      }

      config.body = bodyData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response.status)
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: currentId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: currentId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    tableVariantAddCart(btn) {
      const parentTrElement = btn.closest('tr');
      const qtyElement = parentTrElement.querySelector(`[name='quantity']`);
      const qty = qtyElement.value;
      const variantId = parentTrElement.dataset.id;
      const submitButton = btn;
      const loadingSpinner = btn.querySelector('.loading-overlay__spinner');

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      loadingSpinner.classList.remove('hidden');
      
      let data = {
        form_type: "product",
        quantity: qty,
        id: variantId,
      };
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const formData = this.jsToFormData(data)

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
              // this.handleErrorMessage(response.description);
  
              // const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              // if (!soldOutMessage) return;
              // this.submitButton.setAttribute('aria-disabled', true);
              // this.submitButton.querySelector('span').classList.add('hidden');
              // soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
  
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
            this.error = false;
            // const quickAddModal = this.closest('quick-add-modal');
            // if (quickAddModal) {
            //   document.body.addEventListener('modalClosed', () => {
            //     setTimeout(() => { this.cart.renderContents(response) });
            //   }, { once: true });
            //   quickAddModal.hide(true);
            // } else {
              this.cart.renderContents(response);
            // }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) submitButton.removeAttribute('aria-disabled');
            loadingSpinner.classList.add('hidden');
          });
      }

    jsToFormData(data) {
      let formData = new FormData()
  
      for (let[key,value] of Object.entries(data)) {
          formData.append(key, value)
      }
  
      return formData
    }
    

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
